module.exports = __webpack_public_path__ + "static/media/furnished.a8c5d880.svg";